// extracted by mini-css-extract-plugin
module.exports = {"applicationNavigationButtons":"navigationButtons_applicationNavigationButtons__Vw0xY","disabled":"navigationButtons_disabled__QCFM4"};